import { Close } from '@mui/icons-material';
import { Box, FormControlLabel, styled } from '@mui/material';

export const FilterHeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const SearchContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'flex-end',
  width: '100%',
}));

export const FilterSectionContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2.5),
}));

export const FilterLabel = styled(Box)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const ToggleContainer = styled(FormControlLabel)(({ _ }) => ({
  '& .MuiFormControlLabel-label': {
    fontSize: '0.875rem',
  },
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const ChipContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
}));

export const DialogContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  minWidth: '500px',
  maxHeight: '500px',
  overflowY: 'auto',
}));

export const ExactMatchContainer = styled(Box)(({ _ }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const SearchInputContainer = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(1.75),
  width: '100%',
}));

export const DropdownContainer = styled(Box)({
  borderRadius: '50px',
  paddingTop: '8px',
});

export const CloseIconPointer = styled(Close)({
  cursor: 'pointer',
});
